import { render } from "./ResponsableAsignarEditar.vue?vue&type=template&id=5deb538c"
import script from "./ResponsableAsignarEditar.vue?vue&type=script&lang=js"
export * from "./ResponsableAsignarEditar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__